import React, { useState } from 'react'; // eslint-disable-line
import { Grid, Tooltip, Typography, withStyles } from '@material-ui/core';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { OpenModal, openModalAction } from '../../../form-modal/actions';
import downarrow from '../../../master-layout/views/downarrow.svg';
import uparrow from '../../../master-layout/views/uparrow.svg';
import { State } from '../../../redux/root-reducer';
import styles, { StyledComponent } from '../../../styles/styles';
import { BeneficiaryDetails, getPaymentBeneficiaries, Payment } from '../../reducer';

import { Nullable } from '../../../shared-types';
import { ClaimType } from '../../../claim/claim-types';
import { getClaim } from '../../../claim';
import { RaPaymentWTIDetailsView } from './ra-annuity/payment-wti-details ';
import { Warning } from '@material-ui/icons';

interface DispatchProps {
    openModal: OpenModal;
}
interface OwnProps {
    beneficiaryId: string;
    paymentIndex: number;
    payments: Payment[];
}

interface StateProps {
    beneficiaries: BeneficiaryDetails[];
    claimType: Nullable<ClaimType>;
    isReadOnly: boolean;
}

type Props = StyledComponent & DispatchProps & OwnProps & StateProps;
const WTIDetailsExpansion: React.FunctionComponent<Props> = ({
    beneficiaries,
    beneficiaryId,
    classes,
    claimType,
    openModal,
    isReadOnly,
    paymentIndex,
    payments,
}: Props) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const toggleState = (evt: any) => {
        setIsExpanded(value => !value);
        evt.preventDefault();
        return false;
    };
    const claimantIndex = beneficiaries.findIndex(c => c.beneficiaryId === beneficiaryId);
    if (claimantIndex === -1) {
        return null;
    }
    const beneficiary = beneficiaries[claimantIndex] || {};

    const expanderElement = (
        <a href="/#" onClick={toggleState}>
            {isExpanded ? (
                <img alt="collapse" src={uparrow} />
            ) : (
                <img alt="expand" src={downarrow} />
            )}
        </a>
    );
    const expendedTooltip = !isExpanded ? 'Open' : 'Close';
    return (
        <Grid container spacing={0} justify="flex-start">
            <Grid container spacing={0} item xs={12}>
                <Grid item xs={11} container>
                    <Grid item xs={2} lg={2}>
                        <Typography className={classes.marginTop} variant="h6">
                            WTI Details
                        </Typography>
                    </Grid>
                    {claimType === ClaimType.RADeath &&
                        beneficiary?.emailAddress === null &&
                        beneficiary?.wtiCountry === null &&
                        beneficiary?.wtiException === null && (
                            <Grid item xs={12} lg={12}>
                                <Typography style={{ color: '#8b92a7' }}>
                                    {isWTICapture()}
                                    Please ensure sure that you capture WTI Details before paymentss
                                </Typography>
                            </Grid>
                        )}
                </Grid>
            </Grid>
            <Grid
                item
                xs={12}
                lg={12}
                style={{
                    textAlign: 'right',
                    marginTop: '-39px',
                    marginLeft: '-20px',
                }}
            >
                <Tooltip title={expendedTooltip}>{expanderElement}</Tooltip>
            </Grid>
            <React.Fragment>
                <RaPaymentWTIDetailsView personalDetails={beneficiary} />
            </React.Fragment>
        </Grid>
    );
};
function isWTICapture() {
    return <Warning style={{ color: '#ff6c35', marginLeft: '8px', height: '20px' }} />;
}

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => {
    const claim = getClaim(state);
    return {
        beneficiaries: getPaymentBeneficiaries(claim),
        claimType: claim.claimType,
        isReadOnly: state.claimSession.readOnly,
    };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
    dispatch: ThunkDispatch<State, any, AnyAction>
) => ({
    openModal: options => dispatch(openModalAction(options)),
});

export const WTIDetailsExpansionView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(WTIDetailsExpansion));
